import $ from 'jquery';
import React, {Fragment, PureComponent} from 'react';
import I18n from 'app/i18n';
import {localePromoName, promoUrl, serverError, scrollToTop} from 'app/utils';
import Rating from './rating';
import MyPredictions from './my_predictions';
import NoPredictions from './predictions/no_predictions';
import ConversionCard from './predictions/ConversionCard';
import Prediction from './prediction';
import SmartFullPageLoader from 'app/components/reusable/smart_loaders/SmartFullPageLoader';

const FIVE_SECONDS = 5000;

class Predictions extends PureComponent {
    constructor() {
        super();
        this.state = {
            loading: true,
            points_data: {},
            predictionId: null,
            predictions: [],
            showAnswers: false
        };
        this.showAnswersHandler = this.showAnswersHandler.bind(this);
        this.overlayClickHandler = this.overlayClickHandler.bind(this);
        this.updatePredictionsHandler = this.updatePredictionsHandler.bind(this);
        this.submitAnswer = this.submitAnswer.bind(this);
        this.timerId = null;
    }

    componentDidMount() {
        this.updatePredictionsHandler(() => $.get(promoUrl('predictions'), data => this.setState(data))
            .fail(() => serverError())
            .always(() => this.setState({loading: false})));

        scrollToTop();
    }

    componentWillUnmount() {
        clearInterval(this.timerId);
    }

    updatePredictionsHandler(func) {
        if (func) {
            func();
        } else {
            $.get(promoUrl('predictions'), data => {
                this.setState(data);
            });
        }
        this.timerId = setTimeout(this.updatePredictionsHandler, FIVE_SECONDS);
    }

    submitAnswer(predictionId) {
        const prediction = this.state.predictions.find(p => p.id === predictionId);
        prediction.answer_was_given = true;
        this.setState({predictions: [].concat(this.state.predictions)});
    }

    showAnswersHandler(predictionId) {
        this.setState({
            predictionId,
            showAnswers: !this.state.showAnswers
        });
    }

    overlayClickHandler() {
        this.setState({
            showAnswers: !this.state.showAnswers
        });
    }

    overlayClass() {
        const classes = ['compendium-grid__global-overlay'];

        if (this.state.showAnswers) {
            classes.push('compendium-grid__global-overlay--shown');
        }
        return classes.join(' ');
    }

    render() {
        const {predictions, predictionId, showAnswers, loading, points_data: {prediction_points}} = this.state;

        return <>
            <div className="predictions-title">
                <h1 className="title-h1">{I18n.t(`user.promo_action.${localePromoName()}.predictions`)}</h1>
                <ConversionCard prediction_points={prediction_points} loaded={loading}/>
            </div>
            <div className="compendium">
                {loading
                    ? <SmartFullPageLoader/>
                    : <Fragment>
                        {predictions.length === 0 && <NoPredictions/>}
                        <div className="compendium-grid">
                            <div className={this.overlayClass()} onClick={this.overlayClickHandler}/>
                            <div className="compendium-grid__items">
                                {predictions.map(prediction => <Prediction key={prediction.id}
                                    ref={prediction.id}
                                    showAnswersHandler={this.showAnswersHandler}
                                    reward={prediction.reward}
                                    submitAnswer={this.submitAnswer}
                                    answerWasGiven={prediction.answer_was_given}
                                    selected={predictionId === prediction.id && showAnswers}
                                    {...prediction}/>)}
                            </div>
                        </div>
                    </Fragment>}
            </div>
        </>;
    }
}

export default {
    MyPredictions,
    Predictions,
    Rating
};
